import { HttpErrorResponse, HttpEvent } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { WbsRisk } from '../../../features/feature-wbs/models/interfaces/wbs-risk.interface'
import { WbsDeliverableListItem } from '../../../features/feature-wbs/models/interfaces/wbs-deliverable.interface'
import { WbsMilestoneListItem } from '../../../features/feature-wbs/models/interfaces/wbs-milestone.interface'
import { WbsWorkpackageListItem } from '../../../features/feature-wbs/models/interfaces/wbs-workpackage.interface'

export const exportGantt = createAction('[wbs] exportGantt')

export const exportGanttSuccess = createAction('[wbs] exportGanttSuccess', props<{ response: HttpEvent<Blob> }>())

export const exportGanttFailed = createAction('[budget] exportGanttFailed', props<{ error: HttpErrorResponse }>())

export const loadWorkpackageList = createAction('[wbs] loadWorkpackageList')

export const loadWorkpackageListSuccess = createAction('[wbs] loadWorkpackageListSuccess', props<{ response: WbsWorkpackageListItem[] }>())

export const loadWorkpackageListFailed = createAction('[wbs] loadWorkpackageListFailed', props<{ error: HttpErrorResponse }>())

export const clearWorkpackageList = createAction('[wbs] clearWorkpackageList')

export const exportWorkpackageList = createAction('[wbs] exportWorkpackageList')

export const exportWorkpackageListSuccess = createAction('[wbs] exportWorkpackageListSuccess', props<{ response: HttpEvent<Blob> }>())

export const exportWorkpackageListFailed = createAction('[wbs] exportWorkpackageListFailed', props<{ error: HttpErrorResponse }>())

export const loadDeliverableList = createAction('[wbs] loadDeliverableList')

export const loadDeliverableListSuccess = createAction('[wbs] loadDeliverableListSuccess', props<{ response: WbsDeliverableListItem[] }>())

export const loadDeliverableListFailed = createAction('[wbs] loadDeliverableListFailed', props<{ error: HttpErrorResponse }>())

export const clearDeliverableList = createAction('[wbs] clearDeliverableList')

export const exportDeliverableList = createAction('[wbs] exportDeliverableList', props<{ includeDescription: boolean }>())

export const exportDeliverableListSuccess = createAction('[wbs] exportDeliverableListSuccess', props<{ response: HttpEvent<Blob> }>())

export const exportDeliverableListFailed = createAction('[wbs] exportDeliverableListFailed', props<{ error: HttpErrorResponse }>())

export const loadMilestoneList = createAction('[wbs] loadMilestoneList')

export const loadMilestoneListSuccess = createAction('[wbs] loadMilestoneListSuccess', props<{ response: WbsMilestoneListItem[] }>())

export const loadMilestoneListFailed = createAction('[wbs] loadMilestoneListFailed', props<{ error: HttpErrorResponse }>())

export const exportMilestoneList = createAction('[wbs] exportMilestoneList')

export const exportMilestoneListSuccess = createAction('[wbs] exportMilestoneListSuccess', props<{ response: HttpEvent<Blob> }>())

export const exportMilestoneListFailed = createAction('[wbs] exportMilestoneListFailed', props<{ error: HttpErrorResponse }>())

export const clearMilestoneList = createAction('[wbs] clearMilestoneList')

export const loadRiskList = createAction('[wbs] loadRiskList')

export const loadRiskListSuccess = createAction('[wbs] loadRiskListSuccess', props<{ response: WbsRisk[] }>())

export const loadRiskListFailed = createAction('[wbs] loadRiskListFailed', props<{ error: HttpErrorResponse }>())

export const clearRiskList = createAction('[wbs] clearRiskList')

export const clearRiskActive = createAction('[wbs] clearRiskActive')

export const exportRiskList = createAction('[wbs] exportRiskList')

export const exportRiskListSuccess = createAction('[wbs] exportRiskListSuccess', props<{ response: HttpEvent<Blob> }>())

export const exportRiskListFailed = createAction('[wbs] exportRiskListFailed', props<{ error: HttpErrorResponse }>())

export const closeExportProgress = createAction('[wbs] closeExportProgress')

export const loadRisk = createAction('[wbs] loadRisk', props<{ id: number }>())

export const loadRiskSuccess = createAction('[wbs] loadRiskSuccess', props<{ response: WbsRisk }>())

export const loadRiskFailed = createAction('[wbs] loadRiskFailed', props<{ error: HttpErrorResponse }>())

export const addRisk = createAction('[wbs] addRisk', props<{ data: Partial<WbsRisk> }>())

export const addRiskSuccess = createAction('[wbs] addRiskSuccess')

export const addRiskFailed = createAction('[wbs] addRiskFailed', props<{ error: HttpErrorResponse }>())

export const updateRisk = createAction('[wbs] updateRisk', props<{ id: number; data: Partial<WbsRisk> }>())

export const updateRiskSuccess = createAction('[wbs] updateRiskSuccess')

export const updateRiskFailed = createAction('[wbs] updateRiskFailed', props<{ error: HttpErrorResponse }>())

export const deleteRisk = createAction('[wbs] deleteRisk', props<{ id: number }>())

export const deleteRiskSuccess = createAction('[wbs] deleteRiskSuccess')

export const deleteRiskFailed = createAction('[wbs] deleteRiskFailed', props<{ error: HttpErrorResponse }>())

export const updateRiskOrder = createAction('[wbs] updateRiskOrder', props<{ data: number[] }>())

export const updateRiskOrderSuccess = createAction('[wbs] updateRiskOrderSuccess')

export const updateRiskOrderFailed = createAction('[wbs] updateRiskOrderFailed', props<{ error: HttpErrorResponse }>())

export const copyRisk = createAction('[wbs] copyRisk', props<{ id: number }>())

export const copyRiskSuccess = createAction('[wbs] copyRiskSuccess')

export const copyRiskFailed = createAction('[wbs] copyRiskFailed', props<{ error: HttpErrorResponse }>())
